/* tslint:disable:no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('register')
    },
    registered() {
      console.log('register complete')
    },
    updatefound() {
      console.log('update')
    },
    updated() {
      console.log('update complete')
    },
    offline() {
      console.log('offline')
    },
    error(error) {
      console.error('error:', error)
    }
  })
}
